import React from 'react';
export function UrgencyBar() {
  return <div className="bg-charcoal text-white sticky top-0 z-50 border-b border-gold/20" data-id="element-193">
      <div onClick={() => {
      const priceCard = document.getElementById('price-card');
      if (priceCard) {
        priceCard.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }} className="max-w-xl mx-auto px-4 py-2.5 flex flex-col items-center text-center gap-0.5 cursor-pointer" data-id="element-194">
        <p className="text-xs md:text-sm" data-id="element-195">
          <span className="text-base align-middle" data-id="element-196">🕊️</span> Cientos de personas
          ya liberaron su historia.
        </p>
        <p className="text-xs md:text-sm font-medium" data-id="element-197">
          Esta <span className="text-gold font-bold" data-id="element-198">SEMANA SANTA</span> es tu
          momento de <span className="text-gold font-bold" data-id="element-199">FE</span>.
        </p>
        <p className="text-xs md:text-sm mt-0.5" data-id="element-200">
          El precio especial de{' '}
          <span className="text-gold font-bold" data-id="element-201">$8.49 USD</span> expira el:
        </p>
        <p className="text-gold font-serif font-bold text-xs md:text-sm italic" data-id="element-202">
          Viernes Santo — 3 de Abril — 11:59 PM
        </p>
      </div>
    </div>;
}